/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import IconLink from "@mui/icons-material/Link";
import "./Advisories.css";
import moment from "moment";
import { dateFormat } from "../../app/utils";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAdvisories,
  resetStateAdvisories,
} from "../../app/slices/advisoriesSlice";
import LoadingContainer from "../../components/LoadingContainer/LoadingContainer";
import ErrorContainer from "../../components/ErrorContainer/ErrorContainer";
import { useNavigate } from "react-router-dom";

const AdvisoryDetails = () => {
  const {
    data: advisoriesList,
    status: statusAdvisories,
    error: errorAdvisories,
  } = useSelector(({ advisories }) => advisories.get);

  const [advisory, setAdvisory] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  //use effects
  useEffect(() => {
    dispatch(resetStateAdvisories());
    let url = new URL(window.location.href);
    const id = url?.searchParams?.get("id");
    if (id === null || id === undefined) {
      navigate("/not-found");
    } else {
      dispatch(
        fetchAdvisories({
          advisory_id: id,
        })
      );
    }
    return () => {
      dispatch(resetStateAdvisories());
    };
  }, []);

  useEffect(() => {
    if (advisoriesList?.length > 0) {
      setAdvisory(advisoriesList[0]);
    }
  }, [advisoriesList]);

  //builders
  return (
    <div className="advisory-details app-padding mb-20">
      {statusAdvisories === "idle" && advisory !== null && (
        <>
          <h1 className="mt-30">{advisory?.title}</h1>
          <small>Reference:</small>
          <p>{advisory?.reference_number}</p>
          <small>Published On:</small>
          <p>{moment(advisory?.published_date).format(dateFormat)}</p>
          <small>Source:</small>
          <p>{advisory?.source}</p>
          <small>Software Affected:</small>
          <p>{advisory?.affected_softwares}</p>

          <div className="mt-10 mb-30">
            <div className="category">
              <h3>Overview</h3>
              <p>{advisory?.overview}</p>
            </div>
            <div className="category">
              <h3>Description</h3>
              <p>{advisory?.description}</p>
            </div>
            <div className="category">
              <h3>Impact</h3>
              <p>{advisory?.impact}</p>
            </div>
            {advisory?.references?.length > 0 && (
              <div className="category">
                <h3>References</h3>
                <div className="flex-row mt-10">
                  {advisory?.references?.map((item) => {
                    let _item = JSON.parse(item);
                    return (
                      <a href={_item?.link}>
                        <div className="link-chip">
                          <IconLink />
                          {_item?.title}
                        </div>
                      </a>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </>
      )}

      {statusAdvisories === "loading" && (
        <LoadingContainer message={"Loading, please wait ..."} />
      )}

      {errorAdvisories !== null && statusAdvisories !== "loading" && (
        <ErrorContainer
          message={errorAdvisories?.message}
          onReload={() => {
            window.location.href = window.location.href;
          }}
        />
      )}
    </div>
  );
};

export default AdvisoryDetails;
